import {QuoteStream} from "./quote.stream";

export class ClickThrottler {
    private clickCount = 0;
    private timeoutId: number | null = null;
    private readonly delayCb: () => number;
    private readonly callback: (stream: QuoteStream, direction: string, clickCount: number) => void;
    private direction: string;
    private stream: QuoteStream;

    constructor(stream: QuoteStream, direction: string, delay: () => number,
                callback: (stream: QuoteStream, direction: string, clickCount: number) => void) {
        this.stream = stream;
        this.direction = direction;
        this.delayCb = delay;
        this.callback = callback;
    }

    getDirection(): string {
        return this.direction;
    }

    public click(): void {
        // Increment click count
        this.clickCount++;

        // Clear existing timeout if any
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
        }

        // Set new timeout
        this.timeoutId = <any>setTimeout(() => {
            // Execute callback with accumulated click count
            this.callback(this.stream, this.direction, this.clickCount);

            // Reset for next sequence
            this.clickCount = 0;
            this.timeoutId = null;
        }, this.delayCb());
    }

    public destroy(): void {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        this.clickCount = 0;
    }
}